import _ from 'lodash'

import React, { useMemo } from 'react'
import Tag from './Tag'

// type OwnProps = {
//   status: TransactionStatusType,
//   big?: boolean,
//   block?: boolean, // only applicable when `styl = tag`
// };

export const transactionStatus = {
	pending: 'PENDING',
	failed: 'FAILED',
	authorized: 'AUTHORIZED',
	settling: 'SETTLING',
	partiallySettled: 'PARTIALLY_SETTLED',
	settling: 'SETTLING',
	settled: 'SETTLED',
	declined: 'DECLINED',
	cancelled: 'CANCELLED',
}

export default function TxnTag(props) {
	const { status, big, block } = props

	const sentiment = useMemo(() => {
		switch (status) {
			case transactionStatus.authorized:
			case transactionStatus.partiallySettled:
			case transactionStatus.settled:
				return 'positive'

			case transactionStatus.failed:
			case transactionStatus.declined:
				return 'negative'

			case transactionStatus.cancelled:
				return 'attentive'

			case transactionStatus.pending:
			case transactionStatus.settling:
				return 'neutral'
			default:
				return 'neutral'
		}
	}, [status])

	const text = status

	return <Tag size={big ? 'big' : 'small'} sentiment={sentiment} text={text} block={block} styl='regularNoBorder' />
}
